module.exports = {
  "/": {
    "success": {
      "default": [
        "TODO_THIS_ALWAYS_REDIRECTS_WE_NEED_A_WAY_TO_HANDLE_THIS"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "rootView"
  },
  "/crm": {
    "success": {
      "default": [
        "FREE_TOOLS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "freePage"
  },
  "/bundle": {
    "success": {
      "default": [
        "BUNDLE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "bundlePage"
  },
  "/marketing": {
    "success": {
      "default": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPage"
  },
  "/sales": {
    "success": {
      "default": [
        "SALES_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "salesPage"
  },
  "/service": {
    "success": {
      "default": [
        "SERVICE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "servicePage"
  },
  "/cms": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "cmsPage"
  },
  "/content": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "contentPage"
  },
  "/operations": {
    "success": {
      "default": [
        "OPERATIONS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "operationsPage"
  },
  "/commerce": {
    "success": {
      "default": [
        "COMMERCE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "commercePage"
  },
  "/suite": {
    "success": {
      "default": [
        "SUITE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "suitePage"
  },
  "/marketing-plus": {
    "success": {
      "default": [
        "MARKETING_PLUS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPlusPage"
  },
  "/splash": {
    "success": {
      "default": [
        "SPLASH_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "splashPage"
  },
  "/interstitial": {
    "success": {
      "default": [
        "INTERSTITIAL_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "interstitialPage"
  },
  "/add-ons": {
    "success": {
      "default": [
        "ADD_ONS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "addOnsPage"
  },
  "/breeze-intelligence": {
    "success": {
      "default": [
        "BREEZE_INTELLIGENCE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "breezeIntelligencePage"
  },
  "/recommended": {
    "success": {
      "default": [
        "RECOMMENDED_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "recommendedPage"
  },
  "/smart-crm": {
    "success": {
      "default": [
        "SMART_CRM_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "smartCrmPage"
  }
};